import { useEffect, useState } from 'preact/hooks';
import { getZone } from '../../content';
import { api } from '../../ui/app/api';
import { closePanel, openPanel } from '../../ui/app/store';
import { Window } from '../../ui/app/Window';
import { eventBanner } from './runtime';
import { calendar, fmtCountdown } from './schedule';

function useNow(ms = 1000): number {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(id);
  }, [ms]);
  return now;
}

const clock = (t: number) => new Date(t).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

/** Procyon-style event calendar: what happens where, and when. */
export function EventsPanel() {
  const now = useNow();
  const level = api().progression?.char.level ?? 1;
  const rows = calendar(now, 2);
  return (
    <Window title="World Events" width={560} onClose={closePanel}>
      <p class="muted ev-intro">Field bosses and Aether Breaches follow a fixed daily schedule. Every adventurer in the zone can join in.</p>
      <table class="ev-table">
        <tbody>
          {rows.map((o) => {
            const zone = getZone(o.zone);
            const low = level < o.def.level - 5;
            return (
              <tr key={`${o.def.id}:${o.start}`} class={o.active ? 'live' : ''}>
                <td class="ev-time">{o.active ? 'NOW' : clock(o.start)}</td>
                <td>
                  <b class={o.def.kind === 'fieldBoss' ? 'ev-boss' : 'ev-breach'}>{o.def.name}</b>
                  <div class="muted ev-desc">{o.def.description}</div>
                </td>
                <td>
                  {zone.name}
                  <div class={low ? 'err' : 'muted'}>Lv {o.def.level}+</div>
                </td>
                <td class="ev-count">{o.active ? `${fmtCountdown(o.end - now)} left` : `in ${fmtCountdown(o.start - now)}`}</td>
                <td>
                  {api().zoneId !== o.zone ? (
                    <button class="btn" onClick={() => openPanel('waystone')}>
                      Travel
                    </button>
                  ) : (
                    <span class="ok">Here</span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Window>
  );
}

/** Small banner under the minimap while an event is near or running in this zone. */
export function EventBanner() {
  const b = eventBanner.value;
  if (!b) return null;
  return (
    <div class={`ev-banner tone-${b.tone}`}>
      <b>{b.title}</b>
      <span>{b.detail}</span>
    </div>
  );
}
